export default __webpack_public_path__ + "static/media/gallery_03.9b920a11.jpg";